// Catalogue officiel des phases de chantier BTP utilisable dans CHANTIX
// Source : pratiques reelles OPC/CSPS terrain
// Cle = identifiant technique stable. Label = affichage utilisateur.
// Groupe = etape macro pour le tri visuel.

export const BTP_PHASES = [
  // Phase amont
  { key: 'consultation',   label: "Consultation / Appel d'offres", group: 'Amont' },
  { key: 'etudes',         label: 'Etudes',                         group: 'Amont' },
  { key: 'conception',     label: 'Conception',                     group: 'Amont' },
  { key: 'etudes_exec',    label: "Etudes d'execution",             group: 'Amont' },

  // Preparation chantier
  { key: 'preparation',    label: 'Preparation',                    group: 'Preparation' },
  { key: 'installation',   label: 'Installation chantier',          group: 'Preparation' },
  { key: 'terrassement_vrd', label: 'Terrassement / VRD',           group: 'Preparation' },

  // Realisation (corps d'etat)
  { key: 'gros_oeuvre',    label: 'Gros oeuvre',                    group: 'Corps d\'etat' },
  { key: 'charpente',      label: 'Charpente',                      group: 'Corps d\'etat' },
  { key: 'couverture',     label: 'Couverture',                     group: 'Corps d\'etat' },
  { key: 'facade',         label: 'Facade',                         group: 'Corps d\'etat' },
  { key: 'cloisons',       label: 'Cloisons',                       group: 'Corps d\'etat' },
  { key: 'plomberie_cvc',  label: 'Plomberie / CVC',                group: 'Corps d\'etat' },
  { key: 'electricite',    label: 'Electricite',                    group: 'Corps d\'etat' },
  { key: 'finitions',      label: 'Finitions',                      group: 'Corps d\'etat' },

  // Generique (compat)
  { key: 'realisation',    label: 'Realisation (toutes phases)',    group: 'Generique' },

  // Reception
  { key: 'opr',            label: 'OPR (Operations Prealables a la Reception)', group: 'Reception' },
  { key: 'reception',      label: 'Reception',                      group: 'Reception' },
  { key: 'livraison',      label: 'Livraison',                      group: 'Reception' },
  { key: 'gpa',            label: "GPA (Garantie de Parfait Achevement)", group: 'Reception' },
];

// Map cle -> definition pour acces O(1) dans les badges
export const PHASE_MAP = BTP_PHASES.reduce((acc, p) => {
  acc[p.key] = p; return acc;
}, {});

// Couleur par groupe pour les badges
const GROUP_BADGE_CLS = {
  'Amont':       'chantix-badge-info',
  'Preparation': 'chantix-badge-info',
  "Corps d'etat":'chantix-badge-warning',
  'Generique':   'chantix-badge-warning',
  'Reception':   'chantix-badge-success',
};

// Retourne { label, cls } pour afficher une phase (compat phases existantes + custom)
export function getPhaseDisplay(phaseKey) {
  if (!phaseKey) return { label: 'N/A', cls: 'chantix-badge-neutral' };
  const p = PHASE_MAP[phaseKey];
  if (p) return { label: p.label, cls: GROUP_BADGE_CLS[p.group] || 'chantix-badge-neutral' };
  // Phase personnalisee (non dans le catalogue) -> badge violet
  return { label: phaseKey, cls: 'chantix-badge-custom' };
}

// Liste groupee pour les composants Select
export function getPhasesGrouped() {
  const groups = {};
  BTP_PHASES.forEach((p) => {
    if (!groups[p.group]) groups[p.group] = [];
    groups[p.group].push(p);
  });
  return groups;
}
